import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=9e1a0b4e&scoped=true&"
import script from "./Admins.vue?vue&type=script&lang=js&"
export * from "./Admins.vue?vue&type=script&lang=js&"
import style0 from "./Admins.vue?vue&type=style&index=0&id=9e1a0b4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1a0b4e",
  null
  
)

export default component.exports